import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=b4ee1568&scoped=true&"
import script from "./FileReader.vue?vue&type=script&lang=js&"
export * from "./FileReader.vue?vue&type=script&lang=js&"
import style0 from "./FileReader.vue?vue&type=style&index=0&id=b4ee1568&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ee1568",
  null
  
)

export default component.exports